import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RequestEarlyAccessMutationVariables = Types.Exact<{
  input: Types.RequestEarlyAccessInput;
}>;


export type RequestEarlyAccessMutation = { __typename?: 'Mutation', requestEarlyAccess: { __typename?: 'RequestEarlyAccessPayload', requestedByMe: boolean, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RequestEarlyAccessDocument = new TypedDocumentString(`
    mutation RequestEarlyAccess($input: RequestEarlyAccessInput!) {
  requestEarlyAccess(input: $input) {
    requestedByMe
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RequestEarlyAccess: build.mutation<RequestEarlyAccessMutation, RequestEarlyAccessMutationVariables>({
      query: (variables) => ({ document: RequestEarlyAccessDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRequestEarlyAccessMutation } = injectedRtkApi;
